export const educationalRegistrationTranslations = {
  lv: {
    registerInstitution: 'Reģistrēt izglītības iestādi',
    title: 'Piekrišana Edy365.com lietošanas noteikumiem',
    subtitle: 'Lai turpinātu, lūdzu, apstipriniet noteikumus.',
    introduction:
      'Pirms Platformas lietošanas uzsākšanas lūdzam iepazīties ar Edy365.com Lietošanas noteikumiem un Personas datu apstrādes vienošanos.',
    authorityDescription:
      'Apstiprinot, Jūs apliecināt, ka rīkojaties attiecīgās izglītības iestādes vārdā un Jums ir tiesības uzņemties saistības tās vārdā.',
    termsTitle: 'Edy365.com lietošanas noteikumi izglītības iestādēm',
    dataPolicyTitle: 'Personas datu apstrādes vienošanās (DPA)',
    viewDocument: 'Skatīt dokumentu',
    viewDocumentLabel: 'Skatīt dokumentu: {{document}}',
    acceptTerms:
      'Es apliecinu, ka esmu iepazinies/-usies un piekrītu Edy365.com Lietošanas noteikumiem.',
    acceptDataPolicy:
      'Es apliecinu, ka esmu iepazinies/-usies un piekrītu Personas datu apstrādes vienošanās noteikumiem.',
    termsRequired: 'Apstipriniet piekrišanu lietošanas noteikumiem',
    dataPolicyRequired: 'Apstipriniet piekrišanu datu apstrādes vienošanās noteikumiem',
    institutionData: 'Izglītības iestādes dati',
    institutionName: 'Izglītības iestādes nosaukums',
    registrationNumber: 'Reģistrācijas numurs',
    vatNumber: 'PVN numurs (neobligāti)',
    address: 'Adrese',
    website: 'Tīmekļvietne (neobligāti)',
    authorizedPerson: 'Pilnvarotā persona',
    position: 'Amats',
    authorityConfirmation:
      'Apliecinu, ka man ir tiesības pārstāvēt izglītības iestādi vai esmu tās pilnvarota persona.',
    authorityRequired: 'Apstipriniet savas tiesības pārstāvēt izglītības iestādi',
    administrativeUser: 'Administratīvais lietotājs',
    optionalPhone: 'Tālrunis (neobligāti)',
    required: 'Aizpildiet šo lauku',
    websiteInvalid: 'Ievadiet derīgu tīmekļvietnes adresi ar http:// vai https://',
    optionalPhoneInvalid: 'Ievadiet derīgu tālruņa numuru',
    confirmAndContinue: 'Apstiprināt un turpināt',
    submitErrorTitle: 'Reģistrācija neizdevās',
    submitError: 'Neizdevās nosūtīt reģistrācijas pieteikumu. Mēģiniet vēlreiz.',
    linkSentTitle: 'Pārbaudiet e-pastu',
    linkSent:
      'Reģistrācijas apstiprināšanas saite nosūtīta uz {{email}}. Saite ir aktīva 24 stundas un izmantojama vienu reizi.',
    completeTitle: 'Izglītības iestādes reģistrācijas pabeigšana',
    completeDescription:
      'Apstipriniet reģistrāciju, lai izveidotu izglītības iestādes kontu un tās administratora piekļuvi.',
    complete: 'Pabeigt reģistrāciju',
    completeErrorTitle: 'Reģistrāciju neizdevās pabeigt',
    completeError: 'Neizdevās pabeigt reģistrāciju. Mēģiniet vēlreiz.',
    invalidLink: 'Reģistrācijas saite nav derīga vai tās derīguma termiņš ir beidzies.',
    completedTitle: 'Reģistrācija pabeigta',
    completedNewAccount:
      '{{organization}} ir reģistrēta. Administratora konta pieteikšanās dati nosūtīti uz {{email}}.',
    completedExistingAccount:
      '{{organization}} ir reģistrēta. Piesakieties ar savu esošo kontu {{email}}.',
    goToLogin: 'Doties uz pieteikšanos',
  },
  en: {
    registerInstitution: 'Register educational institution',
    title: 'Consent to Edy365.com Terms of Use',
    subtitle: 'To continue, please confirm the terms.',
    introduction:
      'Before starting to use the Platform, please familiarize yourself with the Edy365.com Terms of Use and the Personal Data Processing Agreement.',
    authorityDescription:
      'By confirming, you certify that you are acting on behalf of the respective educational institution and have the authority to undertake obligations on its behalf.',
    termsTitle: 'Edy365.com Terms of Use for Educational Institutions',
    dataPolicyTitle: 'Personal Data Processing Agreement (DPA)',
    viewDocument: 'View document',
    viewDocumentLabel: 'View document: {{document}}',
    acceptTerms: 'I certify that I have read and agree to the Edy365.com Terms of Use.',
    acceptDataPolicy:
      'I certify that I have read and agree to the Personal Data Processing Agreement terms.',
    termsRequired: 'Agree to the Terms of Use',
    dataPolicyRequired: 'Agree to the Data Processing Agreement',
    institutionData: 'Educational institution data',
    institutionName: 'Educational institution name',
    registrationNumber: 'Registration number',
    vatNumber: 'VAT number (optional)',
    address: 'Address',
    website: 'Webpage (optional)',
    authorizedPerson: 'Authorized person',
    position: 'Position',
    authorityConfirmation:
      'I certify that I have the authority to represent the educational institution or am its authorized person.',
    authorityRequired: 'Confirm your authority to represent the educational institution',
    administrativeUser: 'Administrative user',
    optionalPhone: 'Phone (optional)',
    required: 'Complete this field',
    websiteInvalid: 'Enter a valid website address starting with http:// or https://',
    optionalPhoneInvalid: 'Enter a valid phone number',
    confirmAndContinue: 'Confirm and continue',
    submitErrorTitle: 'Registration failed',
    submitError: 'The registration request could not be sent. Please try again.',
    linkSentTitle: 'Check your email',
    linkSent:
      'A link to confirm the registration was sent to {{email}}. The link is active for 24 hours and can be used once.',
    completeTitle: 'Complete educational institution registration',
    completeDescription:
      'Confirm the registration to create the educational institution account and its administrator access.',
    complete: 'Complete registration',
    completeErrorTitle: 'Registration could not be completed',
    completeError: 'The registration could not be completed. Please try again.',
    invalidLink: 'The registration link is not valid or has expired.',
    completedTitle: 'Registration complete',
    completedNewAccount:
      '{{organization}} is registered. The administrator sign-in details were sent to {{email}}.',
    completedExistingAccount:
      '{{organization}} is registered. Sign in with your existing account {{email}}.',
    goToLogin: 'Go to sign in',
  },
} as const
